import { connect } from "react-redux"
import React, { Component } from "react"

import {
    updateAddAttachmentsAction,
    updateDeleteAttachmentsAction,
    updateRemoveAttachmentsAction
} from "../../../../actions/attachment-actions"
import { getAttachmentPlaceholderImage } from "../../../../config/util-functions"
import BackgroundImage from "../../../common/BackgroundImage"
import InsightAreaMediaEditList from "./InsightAreaMediaEditList"
import WidgetHeaderButton from "../../../common/WidgetHeaderButton"

export class InsightAreaMediaEditWidget extends Component {
    state = {
        attachmentToAdd: {
            title: "",
            label: "",
            provider: "",
            url: undefined,
            placeholderUrl: undefined
        },
        manuallyAddedLabel: false,
        canAdd: false
    }

    addAttachment = event => {
        event.preventDefault()

        const attachmentToAdd = {
            attachment: this.attachmentElement.files[0],
            fields: {
                labels: `"${this.state.attachmentToAdd.label}"`,
                provider: this.state.attachmentToAdd.provider,
                attachment_title: this.state.attachmentToAdd.title,
                topic_id: this.props.topicId
            },
            url: this.state.attachmentToAdd.url
        }

        this.props.onAddAttachment(attachmentToAdd)

        this.setState({
            attachmentToAdd: {
                title: "",
                label: "",
                provider: "",
                url: undefined,
                placeholderUrl: undefined
            },
            manuallyAddedLabel: false,
            canAdd: false
        })

        // input type="file" is read-only in React. Can't be changed using state.
        this.attachmentElement.value = ""
    }

    updateCurrentAttachment = event => {
        const newState = {
            ...this.state,
            attachmentToAdd: {
                ...this.state.attachmentToAdd,
                [event.target.name]: event.target.value
            }
        }

        const { title, label, provider } = newState.attachmentToAdd

        const canAdd =
            title.length > 0 &&
            label.length > 0 &&
            provider.length > 0 &&
            this.attachmentElement.files.length > 0

        if (event.target.name === "label") {
            newState.manuallyAddedLabel = true
        }

        this.setState({
            ...newState,
            canAdd
        })
    }

    onAttachmentSelect = () => {
        if (this.attachmentElement.files.length) {
            const attachment = this.attachmentElement.files[0]
            const label = this.state.manuallyAddedLabel
                ? this.state.attachmentToAdd.label
                : this.getLabelFromMimetype(attachment.type)

            if (attachment.type.indexOf("image/") > -1) {
                const reader = new FileReader()
                reader.onloadend = () => {
                    this.setState({
                        attachmentToAdd: {
                            ...this.state.attachmentToAdd,
                            attachment,
                            label,
                            url: reader.result,
                            placeholderUrl: undefined
                        }
                    })
                }

                reader.readAsDataURL(attachment)
            } else {
                this.setState({
                    attachmentToAdd: {
                        ...this.state.attachmentToAdd,
                        attachment,
                        placeholderUrl: getAttachmentPlaceholderImage(
                            label,
                            true
                        ),
                        url: undefined,
                        label
                    }
                })
            }
        }
    }

    getLabelFromMimetype = mimetype => {
        if (mimetype.indexOf("video/") > -1) {
            return "video"
        } else if (mimetype.indexOf("audio/") > -1) {
            return "podcast"
        } else {
            return "report"
        }
    }

    render() {
        const { canAdd, attachmentToAdd } = this.state

        return (
            <form className="widget" onSubmit={this.addAttachment}>
                <h3 className="widget-header">
                    <span className="icon icon-media" />
                    Media
                </h3>
                <div className="widget-content visible">
                    <div className="media-container">
                        <BackgroundImage
                            classList={["media-item-thumb"]}
                            imageUrl={
                                attachmentToAdd.url ||
                                attachmentToAdd.placeholderUrl
                            }
                            defaultImageUrl={getAttachmentPlaceholderImage(
                                attachmentToAdd.label
                            )}
                            errorImageUrl={getAttachmentPlaceholderImage(
                                attachmentToAdd.label
                            )}
                            isThumbnail={true}
                        />
                        <div className="media-inputs-container">
                            <input
                                name="dragFile"
                                type="file"
                                ref={attachmentElement =>
                                    (this.attachmentElement = attachmentElement)}
                                onChange={this.onAttachmentSelect}
                                className="form-control media-inputs-file"
                                placeholder="Drag file"
                                required
                            />
                            <input
                                name="title"
                                onChange={this.updateCurrentAttachment}
                                type="text"
                                className="form-control"
                                placeholder="Title"
                                value={attachmentToAdd.title}
                                required
                            />
                            <input
                                name="provider"
                                onChange={this.updateCurrentAttachment}
                                type="text"
                                className="form-control"
                                placeholder="Provider"
                                value={attachmentToAdd.provider}
                                required
                            />
                        </div>
                        <div className="media-select-container">
                            <select
                                name="label"
                                onChange={this.updateCurrentAttachment}
                                className="form-control"
                                value={attachmentToAdd.label}
                                required
                            >
                                <option defaultValue value="" disabled>
                                    Select
                                </option>
                                <option value="podcast">Podcast</option>
                                <option value="report">Report</option>
                                <option value="video">Video</option>
                            </select>
                        </div>
                    </div>
                    <div className="pull-right media-add-container">
                        <WidgetHeaderButton disabled={!canAdd}>
                            Add
                        </WidgetHeaderButton>
                    </div>
                </div>
                {((this.props.media && this.props.media.length > 0) ||
                    (this.props.mediaToAdd &&
                        this.props.mediaToAdd.length > 0)) && (
                    <InsightAreaMediaEditList
                        media={this.props.media}
                        mediaToAdd={this.props.mediaToAdd}
                        onDelete={this.props.onDeleteAttachment}
                        onRemove={this.props.onRemoveAttachment}
                    />
                )}
            </form>
        )
    }
}

const mapStateToProps = ({ authentication, presentation, entities }) => ({
    topicId: presentation.insightAreas.activeId,
    media: presentation.insightAreas.mediaToView.map(
        attachment => entities.attachments[attachment]
    ),
    mediaToAdd: presentation.insightAreas.mediaToAdd
})

const mapDispatchToProps = dispatch => ({
    onDeleteAttachment: attachment =>
        dispatch(updateDeleteAttachmentsAction(attachment)),
    onRemoveAttachment: attachment =>
        dispatch(updateRemoveAttachmentsAction(attachment)),
    onAddAttachment: attachment =>
        dispatch(updateAddAttachmentsAction(attachment))
})

export default connect(mapStateToProps, mapDispatchToProps)(
    InsightAreaMediaEditWidget
)
